import { useQuery } from '@tanstack/vue-query'
import { toValue, type MaybeRefOrGetter } from 'vue'
import { propertyKeys } from '../propertyQueryKeys'
import { getSupersededPropertyDocuments } from '../propertyEndpoints'

export function usePropertySupersededDocumentsQuery(id: MaybeRefOrGetter<string>) {
  return useQuery({
    queryKey: () => propertyKeys.supersededDocuments(toValue(id)),
    queryFn: () => getSupersededPropertyDocuments(toValue(id)),
    enabled: () => Boolean(toValue(id)),
  })
}
